import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  Optional
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "change-password",
    templateUrl: "./change-password.component.html",
    styleUrls: ["./change-password.component.scss"],
    standalone: true,
    imports: [ReactiveFormsModule]
})
// tslint:disable-next-line:one-line
export class ChangePasswordComponent implements OnInit {
  form: UntypedFormGroup;
  attemptedSubmit = false;
  @Input() user = null;
  @Output() close = new EventEmitter();
  @Output()
  submitPass = new EventEmitter<{
    new_password: string;
    old_password: string;
    confirm_password: string;
  }>();
  constructor(
    private builder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { user } = this.data;
    this.user = user;
    this.form = this.builder.group({
      old_password: [null, [Validators.required, Validators.minLength(8)]],
      new_password: [null, [Validators.required, Validators.minLength(8)]],
      confirm_password: [null, [Validators.required, Validators.minLength(8)]]
    });
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.attemptedSubmit = false;
  }

  submitForm() {
    this.attemptedSubmit = true;
    if (
      this.form.valid &&
      this.form.controls["confirm_password"].value ==
        this.form.controls["new_password"].value
    ) {
      this.submitPass.emit(this.form.value);
      this.dialogRef.close(this.form.value);
      this.resetModal();
    }
  }

  ngOnInit(): void {}
}
